import { render, staticRenderFns } from "./serverSideRequests.vue?vue&type=template&id=5e5e44ca&"
import script from "./serverSideRequests.vue?vue&type=script&lang=js&"
export * from "./serverSideRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports